<template>
  <v-dialog v-model="show" width="500">
    <v-card class="mt-2">
      <v-card-title primary-title>
        <span class="headline mb-0"
          >決済用CD の{{ type === 'EDIT' ? '編集' : '追加' }}</span
        >
      </v-card-title>
      <v-card-actions>
        <v-btn :disabled="!canSave" @click="save()">{{
          $t('app.buttons.save')
        }}</v-btn>
        <v-btn @click="back()">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form ref="form">
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  :disabled="type === 'EDIT'"
                  clearable
                  label="決済用CD"
                  required
                  v-model="expenseCode.code"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  clearable
                  label="決済用CD名称"
                  required
                  v-model="expenseCode.name"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ['company', 'expenseCodes'],
  data() {
    return {
      show: false,
      expenseCode: {},
      type: null,
      errors: {
        CODE_EXISTS: '経理コードが既存しています。',
      },
    }
  },
  methods: {
    popup(type, expenseCode) {
      this.show = true
      this.type = type
      this.expenseCode = expenseCode
    },
    back() {
      this.clearData()
      this.$emit('refresh')
    },
    clearData() {
      this.show = false
      this.buyer = {}
    },
    validCreateData() {
      if (
        this.expenseCodes.filter((bc) => bc.code === this.expenseCode.code)
          .length > 0
      ) {
        this.$message('', '経理コードが既存しています。')
        return false
      }
      return true
    },
    validUpdateData() {
      if (
        this.expenseCodes.filter((bc) => bc.code === this.expenseCode.code)
          .length > 1
      ) {
        this.$message('', '経理コードが既存しています。')
        return false
      }
      return true
    },
    save() {
      if (this.type !== 'EDIT' && !this.validCreateData()) return
      if (this.type !== 'EDIT' && !this.company.companyId) {
        this.$emit('addTempExpenseCode', this.expenseCode)
        this.clearData()
        return
      }
      if (this.type === 'EDIT' && !this.validUpdateData()) return
      if (this.type === 'EDIT' && !this.company.companyId) {
        this.clearData()
        return
      }
      if (!this.type || this.type !== 'EDIT') {
        this.$http
          .post(`expense-codes/code`, {
            ...this.expenseCode,
            parentCompanyId: this.company.companyId,
            companyName: this.company.displayName,
          })
          .then(() => {
            this.$message('', '経理コード追加しました。')
            this.back()
          })
          .catch((err) => {
            this.$showError(err)
          })
      } else {
        this.$http
          .put(`expense-codes/code`, {
            ...this.expenseCode,
            parentCompanyId: this.company.companyId,
          })
          .then(() => {
            this.$message('', '経理コード更新しました。')
            this.back()
          })
          .catch((err) => {
            this.$showError(err)
          })
      }
    },
  },
  computed: {
    canSave() {
      return !!(this.expenseCode.code && this.expenseCode.code.trim())
    },
  },
}
</script>
